import { Navigate } from "react-router-dom";
import { getStoredRole } from "../utils/auth";

/**
 * Client-side role gate, layered on top of ProtectedRoute. This is
 * NOT the real security boundary - the API rejects unauthorized
 * roles server-side regardless (see require_roles in the
 * middleware). This just keeps a Admin/User from landing on a page
 * that will immediately show 403 errors everywhere, by redirecting
 * them to /dashboard instead.
 */
function RoleRoute({ allowedRoles, children }) {

    const role = getStoredRole();

    if (!role || !allowedRoles.includes(role)) {

        return <Navigate to="/dashboard" replace />;

    }

    return children;

}

export default RoleRoute;
